<template>
  <Modal v-if="showModalAddDescription" @close="$emit('closeModal')">
    <Loading v-if="loading" />
    <div class="addDescription">
      <div class="addDescription__header">
        <span class="title">{{ $t('addDescription') }}</span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt=""
          @click="$emit('closeModal')"
        />
      </div>
      <div class="addDescription__body">
        <div class="container">
          <InfoAboutDelivery
            :showDecodedSsn="showDecodedSsn"
            @getDecodedSsn="
              $emit('getDecodedSsn', activeReservations.deliveryId)
            "
            :activeReservations="activeReservations"
          />
          <div class="addDescription__body-description">
            <FormKit
              type="form"
              id="description-form"
              v-model="formData"
              :actions="false"
              @submit="submitHandler"
            >
              <label class="label-description" for="description">
                {{ $t('description') }}
              </label>
              <textarea
                v-model="activeReservations.descriptionText"
                id="description"
                class="input-description"
                maxlength="250"
              >
              </textarea>
            </FormKit>
          </div>
        </div>
        <InfoAboutActionLog
          v-if="openInfoAboutActionLog"
          :activeReservations="activeReservations"
        />
      </div>
      <div class="addDescription__buttons">
        <Button
          v-if="activeReservations.actionsLog"
          variant="filled"
          :title="
            $t(openInfoAboutActionLog ? 'hideFullHistory' : 'showFullHistory')
          "
          @click="showInfoAboutActionLog"
        />
        <div class="container">
          <Button
            variant="filled"
            :title="$t('save')"
            @click="saveDescription"
          />
          <Button
            variant="notBordered"
            :title="$t('cancel')"
            @click="$emit('closeModal')"
          />
        </div>
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions } from 'vuex';

import InfoAboutDelivery from './InfoAboutDelivery/InfoAboutDelivery.vue';
import InfoAboutActionLog from './InfoAboutActionLog/InfoAboutActionLog.vue';
import Loading from '@/views/Loading.vue';

@Options({
  name: 'AddDescription',
  emits: ['getDecodedSsn', 'closeModal'],
  props: [
    'showModalAddDescription',
    'activeReservations',
    'idPickupBox',
    'showDecodedSsn'
  ],
  components: {
    InfoAboutDelivery,
    InfoAboutActionLog,
    Loading
  },
  data() {
    return {
      loading: false,
      openInfoAboutActionLog: false,
      formData: {
        reservedTime: 0,
        descriptionText: ''
      }
    };
  },
  methods: {
    ...mapActions('pharmacy', [
      'updateDescription',
      'getPickupBoxesByPharmacy',
      'getPharmacy'
    ]),
    async submitHandler() {
      this.loading = true;

      const boxId = this.idPickupBox;
      const deliveryId = this.activeReservations?.deliveryId;

      const { id } = this.$route.params;

      if (boxId) {
        const payload = {
          descriptionText: this.activeReservations.descriptionText,
          reservedTime: this.activeReservations.reservedTime,
          pickupboxId: boxId
        };
        await this.updateDescription({
          data: payload,
          deliveryId
        });
      } else {
        const payload = {
          descriptionText: this.activeReservations.descriptionText,
          reservedTime: this.activeReservations.reservedTime,
          pharmacyId: id
        };
        await this.updateDescription({
          data: payload,
          deliveryId
        });
      }

      this.loading = false;

      this.$emit('closeModal');

      this.getPharmacy(id);
      await this.getPickupBoxesByPharmacy(id);
    },
    saveDescription() {
      this.$formkit.submit('description-form');
    },
    showInfoAboutActionLog() {
      this.openInfoAboutActionLog = !this.openInfoAboutActionLog;
    }
  }
})
export default class AddDescription extends Vue {}
</script>

<style lang="scss" scoped>
.addDescription {
  max-width: 700px;
  height: 100%;
  padding: 24px;
  .addDescription__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 23px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: $fifteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  .addDescription__body {
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
    .container {
      display: flex;
      justify-content: space-between;
      width: 100%;
      .addDescription__body-description {
        position: relative;
        width: 353px;
        height: 278px;
        margin-left: 16px;
        label {
          position: absolute;
          font-family: 'Ubuntu-Regular';
          top: -6px;
          left: 15px;
          padding: 0 5px;
          background: $white;
          color: $label;
          font-weight: 400;
          font-size: $twelveSize;
          line-height: $fourteenSize;
          z-index: 1;
        }
        textarea {
          width: 319px;
          height: 246px;
          padding: 16px;
          font-size: $fourteenSize;
          border: 1px solid $border;
          border-radius: 8px;
          resize: none;
          &:focus {
            outline: none;
          }
        }
      }
    }
  }
  .addDescription__buttons {
    display: flex;
    justify-content: space-between;
  }
}
</style>
